// Terra Boutique - Theme presets
// Each theme defines CSS variables applied to :root

export const THEMES = {
    terra: {
        name: "Terra Original",
        description: "Pizarra grafito + oro líquido — combina con tu logo Terra Boutique",
        preview: ["#2C2C30", "#D4A744", "#F5F1E8", "#B8975E"],
        vars: {
            "--tb-bg": "#2C2C30",
            "--tb-surface": "#3A3A3F",
            "--tb-surface-2": "#45454B",
            "--tb-surface-elev": "#4F4F55",
            "--tb-gold": "#D4A744",
            "--tb-gold-hi": "#E8BD5C",
            "--tb-warm": "#B8975E",
            "--tb-terracotta": "#C97E5B",
            "--tb-text": "#F5F1E8",
            "--tb-text-2": "#C8C0B0",
            "--tb-muted": "#9A9388",
            "--tb-border": "rgba(245, 241, 232, 0.12)",
            "--tb-border-gold": "rgba(212, 167, 68, 0.5)",
            "--tb-input-bg": "#38383D",
        },
    },
    marfil: {
        name: "Boutique Marfil",
        description: "Crema cálida con oro brillante — elegancia luminosa",
        preview: ["#FAF6EE", "#B8923A", "#2A2420", "#C68E58"],
        vars: {
            "--tb-bg": "#FAF6EE",
            "--tb-surface": "#FFFFFF",
            "--tb-surface-2": "#F0E9DA",
            "--tb-surface-elev": "#FBF8F1",
            "--tb-gold": "#B8923A",
            "--tb-gold-hi": "#D4AB48",
            "--tb-warm": "#C68E58",
            "--tb-terracotta": "#B85C45",
            "--tb-text": "#2A2420",
            "--tb-text-2": "#5A5048",
            "--tb-muted": "#8E867B",
            "--tb-border": "rgba(42, 36, 32, 0.14)",
            "--tb-border-gold": "rgba(184, 146, 58, 0.5)",
            "--tb-input-bg": "#FFFFFF",
        },
    },
    negro: {
        name: "Negro Premium",
        description: "Lujo cinematográfico — fondo oscuro y oro brillante",
        preview: ["#1C1816", "#E5BE5A", "#FAF6EE", "#D49A6A"],
        vars: {
            "--tb-bg": "#1C1816",
            "--tb-surface": "#2A2420",
            "--tb-surface-2": "#352E29",
            "--tb-surface-elev": "#3D352F",
            "--tb-gold": "#E5BE5A",
            "--tb-gold-hi": "#F2D27A",
            "--tb-warm": "#D49A6A",
            "--tb-terracotta": "#E89070",
            "--tb-text": "#FAF6EE",
            "--tb-text-2": "#C8BEB1",
            "--tb-muted": "#8E867B",
            "--tb-border": "rgba(250, 246, 238, 0.14)",
            "--tb-border-gold": "rgba(229, 190, 90, 0.5)",
            "--tb-input-bg": "#221E1A",
        },
    },
    rosa: {
        name: "Rosa Champagne",
        description: "Rosa polvo con champagne dorado — femenino y sofisticado",
        preview: ["#FBF1ED", "#B2845D", "#3A2A2C", "#D49B86"],
        vars: {
            "--tb-bg": "#FBF1ED",
            "--tb-surface": "#FFFFFF",
            "--tb-surface-2": "#F4DDD3",
            "--tb-surface-elev": "#FCF5F1",
            "--tb-gold": "#B2845D",
            "--tb-gold-hi": "#CFA37D",
            "--tb-warm": "#D49B86",
            "--tb-terracotta": "#B26052",
            "--tb-text": "#3A2A2C",
            "--tb-text-2": "#6A5253",
            "--tb-muted": "#9B8584",
            "--tb-border": "rgba(58, 42, 44, 0.14)",
            "--tb-border-gold": "rgba(178, 132, 93, 0.5)",
            "--tb-input-bg": "#FFFFFF",
        },
    },
    salvia: {
        name: "Verde Salvia",
        description: "Salvia botánica con bronce — natural y sereno",
        preview: ["#F2EFE3", "#7C6240", "#2C342C", "#9DA982"],
        vars: {
            "--tb-bg": "#F2EFE3",
            "--tb-surface": "#FBFAF3",
            "--tb-surface-2": "#DDD9C5",
            "--tb-surface-elev": "#F6F4EB",
            "--tb-gold": "#7C6240",
            "--tb-gold-hi": "#9A7C53",
            "--tb-warm": "#9DA982",
            "--tb-terracotta": "#7A5547",
            "--tb-text": "#2C342C",
            "--tb-text-2": "#56624F",
            "--tb-muted": "#838C7A",
            "--tb-border": "rgba(44, 52, 44, 0.14)",
            "--tb-border-gold": "rgba(124, 98, 64, 0.5)",
            "--tb-input-bg": "#FBFAF3",
        },
    },
    marino: {
        name: "Azul Noche",
        description: "Azul marino profundo con oro rosa — clásico contemporáneo",
        preview: ["#1A2238", "#D4A776", "#F4ECDD", "#7A92B5"],
        vars: {
            "--tb-bg": "#1A2238",
            "--tb-surface": "#252E48",
            "--tb-surface-2": "#2F3852",
            "--tb-surface-elev": "#34405E",
            "--tb-gold": "#D4A776",
            "--tb-gold-hi": "#EAC393",
            "--tb-warm": "#7A92B5",
            "--tb-terracotta": "#C97E5B",
            "--tb-text": "#F4ECDD",
            "--tb-text-2": "#C2C9D8",
            "--tb-muted": "#7C849A",
            "--tb-border": "rgba(244, 236, 221, 0.14)",
            "--tb-border-gold": "rgba(212, 167, 118, 0.5)",
            "--tb-input-bg": "#1F2740",
        },
    },
    vitex: {
        name: "ViteX Navy",
        description: "Navy profundo + champagne — paleta internacional ViteX (USA)",
        preview: ["#0F1B2D", "#C9B47A", "#ECEEF3", "#4A6FA5"],
        vars: {
            "--tb-bg": "#0F1B2D",
            "--tb-surface": "#182942",
            "--tb-surface-2": "#213352",
            "--tb-surface-elev": "#2A3F65",
            "--tb-gold": "#C9B47A",
            "--tb-gold-hi": "#E5D29A",
            "--tb-warm": "#8FA4C7",
            "--tb-terracotta": "#4A6FA5",
            "--tb-text": "#ECEEF3",
            "--tb-text-2": "#B7BFD0",
            "--tb-muted": "#8C95A8",
            "--tb-border": "rgba(236, 238, 243, 0.12)",
            "--tb-border-gold": "rgba(201, 180, 122, 0.5)",
            "--tb-input-bg": "#1A2940",
        },
    },
};

export const DEFAULT_THEME = "terra";
export const DEFAULT_THEME_US = "vitex";

export function applyTheme(themeKey) {
    const theme = THEMES[themeKey] || THEMES[DEFAULT_THEME];
    const root = document.documentElement;
    Object.entries(theme.vars).forEach(([k, v]) => root.style.setProperty(k, v));
    root.setAttribute("data-tb-theme", themeKey);
}
